import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

interface PrivacyContextType {
  isPrivacyMode: boolean;
  togglePrivacyMode: () => void;
  setPrivacyMode: (mode: boolean) => void;
}

const PrivacyContext = createContext<PrivacyContextType | undefined>(undefined);

export const PrivacyProvider = ({ children }: { children: ReactNode }) => {
  const [isPrivacyMode, setIsPrivacyMode] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem("isPrivacyMode");
      return stored ? JSON.parse(stored) : false;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    localStorage.setItem("isPrivacyMode", JSON.stringify(isPrivacyMode));
  }, [isPrivacyMode]);

  const togglePrivacyMode = () => setIsPrivacyMode((prev) => !prev);
  const setPrivacyMode = (mode: boolean) => setIsPrivacyMode(mode);

  return (
    <PrivacyContext.Provider
      value={{ isPrivacyMode, togglePrivacyMode, setPrivacyMode }}
    >
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => {
  const context = useContext(PrivacyContext);
  if (context === undefined) {
    return {
      isPrivacyMode: false,
      togglePrivacyMode: () => {},
      setPrivacyMode: () => {},
    };
  }
  return context;
};
